import type { ReactNode } from "react";

export function Card({ title, children, className }: { title?: string; children: ReactNode; className?: string }) {
  return (
    <div className={"card" + (className ? ` ${className}` : "")}>
      {title ? <h2>{title}</h2> : null}
      <div className="body">{children}</div>
    </div>
  );
}

export function Badge({ children, kind }: { children: ReactNode; kind?: "good" | "warn" | "bad" | "" }) {
  const cls = kind ? `badge b-${kind}` : "badge";
  return <span className={cls}>{children}</span>;
}

export function Toolbar({ children }: { children: ReactNode }) {
  return <div className="toolbar">{children}</div>;
}
